<button
  *ngIf="comment.voted !== null"
  type="button"
  class="btn btn-sm"
  [ngClass]="{
    disabled: isSubmitting,
    'btn-outline-danger': !comment.voted.downVote,
    'btn-danger': comment.voted.downVote
  }"
  (click)="toggleDownvote()"
  placement="right"
  ngbTooltip="Vote comment as not useful"
>
  <div style="display: inline-block">
    <i class="icofont icofont-circled-down"></i>
    <span>{{ comment.downVoteCount }}</span>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>

<button
  *ngIf="comment.voted === null"
  type="button"
  class="btn btn-sm btn-outline-danger"
  [ngClass]="{ disabled: isSubmitting }"
  (click)="toggleDownvote()"
  placement="right"
  ngbTooltip="Vote comment as not useful"
>
  <div style="display: inline-block">
    <i class="icofont icofont-circled-down"></i>
    <span>{{ comment.downVoteCount }}</span>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>
